import React from 'react';
import {
  Activity,
  AlignLeft,
  ArrowDown,
  ArrowLeft,
  ArrowLeftRight,
  ArrowUp,
  ArrowUpDown,
  Bell,
  BellOff,
  Calendar,
  CaseSensitive,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronsLeft,
  CircleHelp,
  CirclePlus,
  Copy,
  EllipsisVertical,
  Eye,
  EyeOff,
  FolderCog,
  IdCard,
  Image as LucideImage,
  Info,
  KeyRound,
  LayoutDashboard,
  Link as LucideLink,
  List,
  Maximize,
  Maximize2,
  MessageSquare,
  Minus,
  Palette,
  Paperclip,
  Pause,
  Pencil,
  PencilRuler,
  Play,
  Plus,
  Search,
  Server,
  Settings,
  SlidersHorizontal,
  Star,
  StarHalf,
  Tag,
  Tags,
  Trash2,
  User,
  UserPlus,
  Users,
  WifiOff,
  X as LucideX,
} from 'lucide-react';

import { ReactComponent as Facebook } from '../../../assets/icons/Facebook.svg';
import { ReactComponent as GitHub } from '../../../assets/icons/GitHub.svg';
import { ReactComponent as Google } from '../../../assets/icons/Google.svg';
import { ReactComponent as Linkedin } from '../../../assets/icons/Linkedin.svg';
import { ReactComponent as Microsoft } from '../../../assets/icons/Microsoft.svg';
import { ReactComponent as Trello } from '../../../assets/icons/Trello.svg';
import { ReactComponent as XBrand } from '../../../assets/icons/X.svg';
import { ReactComponent as Youtube } from '../../../assets/icons/Youtube.svg';

/* eslint-disable react/jsx-props-no-spreading, react/function-component-definition, react/destructuring-assignment, react/prop-types */
const lucide = (Comp) => {
  const Wrapped = (props) => <Comp {...props} style={{ fill: 'none', ...(props.style || {}) }} />;
  return Wrapped;
};
/* eslint-enable react/jsx-props-no-spreading, react/function-component-definition, react/destructuring-assignment, react/prop-types */

const IconType = {
  Activity: lucide(Activity),
  AddressCard: lucide(IdCard),
  AngleLeft: lucide(ChevronLeft),
  AngleLeftDouble: lucide(ChevronsLeft),
  AnyMatch: lucide(Search),
  ArrowDown: lucide(ArrowDown),
  ArrowLeftBig: lucide(ArrowLeft),
  Attach: lucide(Paperclip),
  BarsStaggered: lucide(AlignLeft),
  Bell: lucide(Bell),
  BellEmpty: lucide(BellOff),
  Board: lucide(LayoutDashboard),
  Calendar: lucide(Calendar),
  Check: lucide(Check),
  CircleQuestion: lucide(CircleHelp),
  Close: lucide(LucideX),
  Comment: lucide(MessageSquare),
  Duplicate: lucide(Copy),
  EllipsisVertical: lucide(EllipsisVertical),
  Eye: lucide(Eye),
  EyeSlash: lucide(EyeOff),
  Facebook,
  FillDrip: lucide(Palette),
  FullScreen: lucide(Maximize),
  GitHub,
  Google,
  Hide: lucide(EyeOff),
  Image: lucide(LucideImage),
  Info: lucide(Info),
  Key: lucide(KeyRound),
  Label: lucide(Tag),
  Labels: lucide(Tags),
  Link: lucide(LucideLink),
  Linkedin,
  List: lucide(List),
  MatchCase: lucide(CaseSensitive),
  Microsoft,
  Minus: lucide(Minus),
  MoveUpDown: lucide(ArrowUpDown),
  NoConnection: lucide(WifiOff),
  Pause: lucide(Pause),
  Pencil: lucide(Pencil),
  PencilRuler: lucide(PencilRuler),
  Play: lucide(Play),
  Plus: lucide(Plus),
  PlusMath: lucide(CirclePlus),
  ProjectSettings: lucide(FolderCog),
  Server: lucide(Server),
  Settings: lucide(Settings),
  Show: lucide(Eye),
  Sliders: lucide(SlidersHorizontal),
  SortArrowUp: lucide(ArrowUp),
  Star: lucide(Star),
  StarHalf: lucide(StarHalf),
  Switch: lucide(ArrowLeftRight),
  Trash: lucide(Trash2),
  Trello,
  TriangleDown: lucide(ChevronDown),
  User: lucide(User),
  UserAdd: lucide(UserPlus),
  Users: lucide(Users),
  WindowMaximize: lucide(Maximize2),
  X: XBrand,
  Youtube,
};

export default IconType;
